import { styled } from '@linaria/react'
import { font } from '@reapit/elements/utils/font'

/** Stacks the add/delete-all links under an outline row (OutlineActions is a flex-wrap row by default). */
export const OutlineActionsStack = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 0.25rem;
`

export const SectionHeading = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 0.5rem;
  margin-bottom: 0.5rem;
`

export const SectionTitle = styled.h2`
  ${font('lg', 'bold')}
  color: var(--colour-text-primary, #222b33);
  margin: 0;
`

export const SectionHint = styled.span`
  ${font('xs', 'regular')}
  color: var(--colour-text-secondary, #8c99a8);
`

export const TemplatesPanel = styled.div`
  background-color: white;
  border: 1px solid var(--neutral-100, #e5e9ed);
  border-radius: 0.75rem;
  box-shadow: 0 1px 2px rgba(18, 43, 51, 0.06);
  padding: 0.75rem 1.25rem;
  display: flex;
  flex-direction: column;
`

/** Uppercase caption grouping notification rows under their triggering activity. */
export const GroupCaption = styled.div`
  ${font('xs', 'regular')}
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--colour-text-secondary, #8c99a8);
  padding: 0.75rem 0 0.375rem;
`

/** Notification row: source pills / preview / actions. */
export const TemplateRow = styled.div`
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  column-gap: 0.75rem;
  padding: 0.5rem 0;
  border-bottom: 1px solid var(--neutral-100, #e5e9ed);

  &:last-of-type {
    border-bottom: none;
  }
`

/** Action row: activity name / description preview / actions. */
export const ActionRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 12rem) minmax(0, 1fr) auto;
  align-items: center;
  column-gap: 0.75rem;
  padding: 0.625rem 0;
  border-bottom: 1px solid var(--neutral-100, #e5e9ed);

  &:last-of-type {
    border-bottom: none;
  }
`

export const Pills = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 0.375rem;
`

/** Blue tag matching the linked-field pills used elsewhere in the builder. */
export const Pill = styled.span`
  ${font('sm', 'regular')}
  font-family: var(--font-mono, monospace);
  color: var(--colour-text-action, #185fa5);
  background-color: var(--colour-fill-action-lightest, #e6f1fb);
  padding: 0.0625rem 0.4375rem;
  border-radius: 5px;
  white-space: nowrap;
`

/** Neutral tag for the recipient type, distinct from the blue method pill. */
export const NeutralPill = styled.span`
  ${font('sm', 'regular')}
  font-family: var(--font-mono, monospace);
  color: var(--colour-text-secondary, #444441);
  background-color: var(--colour-fill-neutral-lightest, #f1efe8);
  padding: 0.0625rem 0.4375rem;
  border-radius: 5px;
  white-space: nowrap;
`

export const Preview = styled.span`
  ${font('xs', 'regular')}
  color: var(--colour-text-secondary, #607890);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const ActionName = styled.span`
  ${font('sm', 'bold')}
  color: var(--colour-text-primary, #222b33);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const RowActions = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 0.75rem;
  justify-self: end;
`

/** Section holding the copy-from-form action, set off from the outline above by a divider. */
export const CopySection = styled.div`
  border-top: 1px solid var(--neutral-100, #e5e9ed);
  margin-top: 1rem;
  padding-top: 0.75rem;
`

/** Small note above the copy action button in the left panel. */
export const CopyNote = styled.p`
  ${font('xs', 'regular')}
  color: var(--colour-text-secondary, #8c99a8);
  margin: 0 0 0.75rem;
  line-height: 1.5;
`
